// extracted by mini-css-extract-plugin
module.exports = {"emptyStateContainer":"DocumentsEmptyState__emptyStateContainer___bihsH","emptyState":"DocumentsEmptyState__emptyState___CK6as"};